import type { ParsedUrlQuery } from "node:querystring";
import Router from "next/router";
import { LOCALE_PARAMETERS } from "src/constants/locale";

export const removeSearchTermFromUrl = (): ParsedUrlQuery => {
    const remainingQuery = { ...Router.query };
    delete remainingQuery.searchTerm;
    LOCALE_PARAMETERS.forEach(param => delete remainingQuery[param]);

    Router.replace({ pathname: window.location.pathname, query: remainingQuery }, undefined, { shallow: true });

    return remainingQuery;
};
